// Modules
import React, { useCallback, useEffect, useState } from 'react'
import { Intent } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './InputNotice.scss'

// Component: Interface > Input notice
function InputNotice ({ children, className, intent, list, style }) {
	// Data
	// const { translate } = useLanguage('components.interface.inputNotice')
	const content = Array.isArray(list) ? list : [list]
	const isActive = content.length > 0

	// State
	const [isVisible, setIsVisible] = useState(isActive)

	// Functions (Memoized)
	const convertStatusFromOpenToOnDemand = useCallback(() => {
		setIsVisible(false)
		setTimeout(() => setIsVisible(null), 50)
	}, [])

	// Effects
	useEffect(() => {
		setIsVisible(isActive)
		if (isActive) setTimeout(convertStatusFromOpenToOnDemand, 2500)
	}, [convertStatusFromOpenToOnDemand, isActive])

	// Render
	return (
		<span
			data-interface="input-notice"
			className={className}
			style={style}>
			<Tooltip2
				usePortal
				placement="top"
				intent={intent}
				isOpen={isActive ? isVisible : false}
				disabled={!isActive}
				popoverClassName="aix-input-notice-popover"
				content={
					<ul className="aix-input-notice-list">
						{content.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}
					</ul>
				}>
				{children}
			</Tooltip2>
		</span>
	)
}

// Properties
InputNotice.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	intent: PropTypes.string,
	list: PropTypes.oneOfType([
		PropTypes.arrayOf(
			PropTypes.string
		),
		PropTypes.string
	]),
	style: PropTypes.object
}
InputNotice.defaultProps = {
	intent: Intent.WARNING,
	list: []
}

// Export
export default InputNotice
